import { SignupUtmMetadata } from '@gearbelt/global';
import { IBusinessAttribute, SelectorTypes } from '@site-mate/sitemate-global-shared';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface SignUpForm {
  email: string;
  firstName: string;
  lastName: string;
  workspaceName: string;
  password: string;
  businessAttributes: { [key in SelectorTypes]: IBusinessAttribute | null };
  mobile: string;
  timezone: string;
  continent: string;
  isSSOSignUp: boolean;
}

interface SignUpStore {
  signUpStep: SignUpSteps;
  signUpForm: SignUpForm;
  utmMetadata: SignupUtmMetadata | undefined;
  setSignUpStep: (arg0: SignUpSteps) => void;
  setSignUpForm: (arg0: SignUpForm) => void;
  setUtmMetadata: (utmMetadata: SignupUtmMetadata) => void;
  clearSignUpStore: () => void;
}

export enum SignUpSteps {
  Email = 'email',
  UserInfo = 'user-info',
  BusinessAttributes = 'business-attributes',
  UsedGearbeltEmail = 'used-gearbelt-email',
  UsedSitemateEmail = 'used-sitemate-email',
  UsedDomain = 'used-domain',
  MobileNumber = 'mobile-number',
  PhoneVerification = 'phone-verification',
  HumanVerification = 'human-verification',
  WorkspaceBranding = 'workspace-branding',
  Complete = 'complete',
}

export const useSignUpStore = create<SignUpStore>()(
  persist(
    (set) => ({
      signUpStep: SignUpSteps.Email,
      signUpForm: {
        email: '',
        firstName: '',
        lastName: '',
        workspaceName: '',
        password: '',
        businessAttributes: { [SelectorTypes.Vertical]: null, [SelectorTypes.Role]: null, [SelectorTypes.Discipline]: null },
        mobile: '',
        timezone: '',
        continent: '',
        isSSOSignUp: false,
      },
      utmMetadata: undefined,
      setSignUpStep: (signUpStep: SignUpSteps) => set(() => ({ signUpStep })),
      setSignUpForm: (signUpForm: SignUpForm) => set(() => ({ signUpForm })),
      setUtmMetadata: (utmMetadata: SignupUtmMetadata) => set(() => ({ utmMetadata })),
      clearSignUpStore: () => {
        localStorage.removeItem('gb-signup');
      },
    }),
    {
      name: 'gb-signup',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
useSignUpStore.setState((state) => ({ ...state }));
